import { routingDetailActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: {},
  error: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case routingDetailActions.ROUTING_DETAIL_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || false,
        error: null
      };
    case routingDetailActions.ROUTING_DETAIL_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || {},
        error: action.error
      };
    case routingDetailActions.ROUTING_DETAIL:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        error: null
      };
    default:
      return state;
  }
};
